<div class="full-height-parent">
  <app-ie-banner></app-ie-banner>
  <div class="row m-0 full-height-child">
    <div class="col-lg-8 col-md-6 col-sm-12 block-bg-box height-ie" [ngClass]="{ 'bot-position-block-bg': isBoxUp }">
      <section class="product-title-details">
        <figure>
          <a>
            <img src="assets/images/cp_app_logo.png" alt="CP MarketPlace">
          </a>
          <div class="text-center pt-2">
            Digitisation of commercial papers
          </div>
          <footer>
            <small class="copyrightText">Powered by ICICI Bank</small>
          </footer>
        </figure>

        <section *ngIf="!isBoxUp" class="sign-button-box d-sm-block d-md-none d-lg-none">
          <div class="row">
            <div class="col">
              <button type="submit" (click)="toggleCollapse()" class="btn btn-outline-success btn-block">Sign In</button>
            </div>
            <div class="col">
              <button type="submit" class="btn btn-outline-success btn-block">Sign Up</button>
            </div>
          </div>
        </section>

      </section>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 black-bg height-ie" [ngClass]="{ 'bot-position-black-bg': isBoxUp }">
      <div class="login-box-body">
        <div *ngIf="loginType === null">
          <app-main-login-form></app-main-login-form>
        </div>
        <div *ngIf="loginType === 'set-password'">
          <app-set-password-component [loginParams]="loginParams"></app-set-password-component>
        </div>
        <div *ngIf="loginType === 'forgot-password'">
          <app-forgot-password-component [loginParams]="loginParams"></app-forgot-password-component>
        </div>
      </div>
    </div>
  </div>
